import React, { useState } from 'react';
import styles from './ScanToPay.module.css';
import TextInput from '../../../../components/TextInput';
import PopupHeader from '../PopupHeader';

export default function ScanToPay(props) {
    const [checkNumber, setCheckNumber] = useState('');
    const [amount, setAmount] = useState('');
    const { invokeScanToPay, onClose } = props;

    const reset = () => {
        setCheckNumber('');
        setAmount('');
    }

    const request = () => {
        invokeScanToPay && invokeScanToPay({
            checkNumber: checkNumber,
            amount: amount,
        });
    }

    const isDisabled = () => {
        if (checkNumber.length > 0 && amount.length > 0) {
            return false;
        }
        return true;
    }

    const amtPattern = /^(?:\d*\.\d{1,2}|\d+)$/;

    const adjustAmount = amt => {
        if (amt === "") setAmount("");
        if (amt.match(amtPattern)) {
          setAmount(amt);
        }
    }

    return (
        <div className={styles.container}>
            <PopupHeader title={"SCAN TO PAY"} onClose={onClose} containerStyle={styles.heading} />
            <div className={styles.formContainer}>
                <TextInput type="tel" placeholder="Check Number" value={checkNumber} onChange={val => setCheckNumber(val)} inputStyle={styles.textInput} />
                <TextInput type="number" placeholder="Amount" value={amount} onChange={val => adjustAmount(val)} inputStyle={styles.textInput} />
            </div>
            <div className={styles.btnWrapper}>
                <button className={styles.btns} onClick={reset}>RESET</button>
                <button className={styles.btns} onClick={request} disabled={isDisabled()} style={{ opacity: isDisabled() ? 0.4 : 1 }}>PAY NOW</button>
            </div>
        </div>
    );
};